module.exports = __webpack_public_path__ + "graphics/gauges/chart-medium.png";